module.exports = {"210882001":"石桥街道","210882002":"青花街道","210882003":"金桥街道","210882004":"钢都街道","210882005":"南楼街道","210882101":"水源镇","210882102":"沟沿镇","210882103":"石佛镇","210882104":"高坎镇","210882105":"旗口镇","210882106":"虎庄镇","210882107":"官屯镇","210882112":"博洛铺镇","210882113":"永安镇","210882114":"汤池镇","210882115":"建一镇","210882116":"黄土岭镇","210882117":"周家镇","210882400":"大石桥市水稻良种场","210882401":"大石桥市示范场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210882.json
// module id = 515
// module chunks = 0